import { InterfaceEvent } from '../interfaces/InterfaceEvent'
import { useInterfaceElementEvent } from './useInterfaceElementEvent'
import { useInterfaceDocumentEvent } from './useInterfaceDocumentEvent'
import { useBoolean } from 'usehooks-ts'

interface EventListeners {
  onDown?: (event: InterfaceEvent) => any
  onMove?: (event: InterfaceEvent) => any
  onUp?: (event: InterfaceEvent) => any
}

export function useDrag(
  element: HTMLElement | null,
  { onDown, onMove, onUp }: EventListeners,
  condition = true,
): boolean {
  const { value: mouseDown, setTrue: setMouseDown, setFalse: setMouseUp } = useBoolean(false)

  useInterfaceElementEvent(
    element,
    'down',
    (event) => {
      setMouseDown()

      onDown?.(event)
    },
    condition,
  )

  useInterfaceDocumentEvent('move', (event) => onMove?.(event), mouseDown)

  useInterfaceDocumentEvent(
    'up',
    (event) => {
      setMouseUp()

      onUp?.(event)
    },
    mouseDown,
  )

  return mouseDown
}
